import React from 'react'
import { Link } from 'react-router-dom'

function Privacy() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-50 dark:from-gray-950 dark:via-gray-900 dark:to-gray-950">
      <div className="max-w-4xl mx-auto px-4 py-16">
        {/* Header */}
        <div className="text-center mb-12 animate-fade-in">
          <h1 className="text-5xl font-bold mb-4 bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 dark:from-white dark:via-gray-100 dark:to-white bg-clip-text text-transparent tracking-tight">
            Privacy Policy
          </h1>
          <p className="text-xl text-gray-600 dark:text-gray-400 font-light tracking-wide">
            How we handle your data and protect your privacy
          </p>
        </div>

        <div className="space-y-6">
          <div className="premium-card p-8">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
              Data Collection
            </h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
              We do not collect or store any personal data from users. All grading and analysis is performed locally in your browser. Your answer keys and student responses remain on your device.
            </p>
          </div>

          <div className="premium-card p-8">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
              Data Usage
            </h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
              Any data you enter into the application (answer keys and student responses) is only used for the purpose of generating grading results and is not transmitted or stored anywhere. We use browser storage only for your theme preference.
            </p>
          </div>

          <div className="premium-card p-8">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
              Third-Party Services
            </h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
              The application may use third-party AI services for grading analysis, but no personal data is shared with these services. Only the text content needed for grading is sent, and it's not stored by the service providers.
            </p>
          </div>

          <div className="premium-card p-8">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
              Cookies & Tracking
            </h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
              This application does not use cookies or any other tracking technologies. We only store your theme preference locally in your browser for a better user experience. For more details, see our{' '}
              <Link to="/cookie-policy" className="text-primary hover:text-primary-dark underline">
                Cookie Policy
              </Link>.
            </p>
          </div>

          <div className="premium-card p-8">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
              Contact
            </h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-2">
              If you have any questions about our privacy practices, please contact us at{' '}
              <a href="mailto:privacy@aigradingagent.com" className="text-primary hover:text-primary-dark underline">
                privacy@aigradingagent.com
              </a>
            </p>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              Last updated: {new Date().toLocaleDateString()}
            </p>
          </div>
        </div>

        {/* Back Button */}
        <div className="mt-12 text-center">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 text-gray-700 dark:text-gray-300 hover:text-primary dark:hover:text-primary-light font-medium transition-colors"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            Back to App
          </Link>
        </div>
      </div>
    </div>
  )
}

export default Privacy
